export class ExtensionInterface {
  isExtension = true;
}

/**
 * Should only allow abstract classes, however it doesn't seem to catch it always, not sure why exactly...
 */
export type AbstractConstructor<T extends ExtensionInterface> = abstract new () => T; // The abstract constructor should not have any parameters
export type Constructor<T> = new (...args: never[]) => T;

interface ExtensionProvider<T extends ExtensionInterface> {
  provide: AbstractConstructor<T>;
  useValue: T;
}

export interface ExtensionDefinition {
  id: string;
  providers: ExtensionProvider<ExtensionInterface>[];
}

export class ExtensionBuilder {
  private _id: string;
  private _providers: ExtensionProvider<ExtensionInterface>[] = [];

  constructor(id: string) {
    this._id = id;
  }

  add<T extends ExtensionInterface>(provide: AbstractConstructor<T>, useValue: T): this {
    this._providers.push({ provide, useValue });
    return this;
  }

  build(): ExtensionDefinition {
    return {
      id: this._id,
      providers: this._providers,
    };
  }
}
